import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Subtitle1 } from 'src/elements/typography/typography'
import { Button, MenuButton } from '@src/elements/button/button'
import Activity from '@src/data/activity'
import Member from '@src/data/member'
import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import { Checkbox } from '@src/elements/input/checkbox'
import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'
import { Modal } from '@src/elements/modal/modal'
import { Spacer } from '@src/elements/spacer/spacer'
import { DISABLED_FAVORITE_ACTIVITIES } from '@src/util/constants'

import './favorite-activities.sass'

@Component({
  computed: {
    allActivities () {
      return this.$store.state.activities.filter(activity => !DISABLED_FAVORITE_ACTIVITIES.includes(activity.key))
    }
  }
})
export class FavoriteActivities extends Vue {

  @Prop({ required: true })
  member: Member

  protected favoriteActivities: Activity[]
  private newFavoriteActivities: Activity[]
  private allActivities: Activity[]
  private isEditModalVisible: boolean = false
  private apiClient: ApiClient = new ApiClient()

  constructor () {
    super()
    this.favoriteActivities = this.member.favoriteActivities ? this.member.favoriteActivities : []
    this.newFavoriteActivities = Object.assign([], this.favoriteActivities)
  }

  showHideEditModal () {
    this.isEditModalVisible = !this.isEditModalVisible
  }

  updateFavoriteActivities () {
    const favoriteActivityIds = this.newFavoriteActivities.map(activity => activity.id)
    return this.apiClient.put(API.TRAINERS_API.MEMBER_DETAILS.replace('{memberId}', `${this.member.id}`), { member: { favorite_activity_ids: favoriteActivityIds } })
      .then(() => {
        this.favoriteActivities = Object.assign([], this.newFavoriteActivities)
        this.$store.dispatch('showToast', { message: this.$t('PAGE.MEMBERS.STATUS.FAVORITE_ACTIVITIES_SAVED'), fadeOut: true })
      })
      .catch(error => console.log('cannot update favorite activities list', error))
      .finally(() => this.isEditModalVisible = false)
  }

  selectActivity (selectedActivity: Activity) {
    const index = this.newFavoriteActivities.findIndex(activity => activity.key === selectedActivity.key)
    if (index >= 0) {
      this.newFavoriteActivities.splice(index, 1)
    } else {
      this.newFavoriteActivities.push(selectedActivity)
    }
  }

  render (h: CreateElement) {
    const activities = this.favoriteActivities.map((activity: Activity) => {
      return <div class='activity-card'>
        <span>{this.$t('ACTIVITIES.' + activity.key.toUpperCase())}</span>
        <img src={this.getActivityImage(activity.key)} />
      </div>
    })

    return <div class='favorite-activities-wrapper'>
      <div class='row'>
        <Subtitle1>{this.$t('PAGE.MEMBERS.STATUS.FAVORITE_ACTIVITIES')}</Subtitle1>
        {this.renderEditOption(h)}
      </div>

      <Spacer />

      {activities.length > 0 ?
        <div class='activities'> {activities}</div>

        : <ErrorScreen message={this.$t('PAGE.MEMBERS.STATUS.FAVORITE_ACTIVITIES_NONE')} />}

      {this.isEditModalVisible ? this.renderEditor(h) : null}
    </div>
  }

  renderEditOption (h: CreateElement) {
    return <MenuButton>
      <Popover>
        <OptionGroup>
          <div onClick={this.showHideEditModal} ref='edit'><Subtitle1>{this.$t('EDIT')}</Subtitle1></div>
        </OptionGroup>
      </Popover>
    </MenuButton>
  }

  renderEditor (h: CreateElement) {
    const allActivities = this.allActivities.map((activity: Activity) => {
      const isFavorite = this.newFavoriteActivities.find((favoriteActivity: Activity) => {
        return favoriteActivity.key === activity.key
      })

      return <li class='activity-card-small' onClick={() => this.selectActivity(activity)}>
        <img src={activity.image2x} />
        <Checkbox alignment='label-right' value={!!isFavorite} change={() => this.selectActivity(activity)}
                  text={this.$t('ACTIVITIES.' + activity.key.toUpperCase())} />
      </li>
    })

    return <Modal show={true} title={this.$t('PAGE.MEMBERS.STATUS.FAVORITE_ACTIVITIES')} closeCallback={this.showHideEditModal}
                  cssClass={'editable-list'}>
      <ul class='list'>
        {allActivities}
      </ul>

      <div class='btn-row' slot={'footer'}>
        <Button type='outline' ref='cancel' label={this.$t('CANCEL')} click={this.showHideEditModal} />
        <Button type='elevated' ref='button-submit' label={this.$t('UPDATE')} click={this.updateFavoriteActivities} />
      </div>
    </Modal>
  }

  protected getActivityImage (key: string) {
    const activity = this.allActivities.filter(activity => activity.key === key)[0]
    if (activity) {
      return activity.image2x
    }
  }
}
